module.exports = "<div class = \"row\">\n    <div class=\"col-xs-12 d-block d-md-none text-center\">\n        <div class=\"mb-4\"></div>\n        <logo ctrl=\"ctrl\"></logo>\n        <div class=\"mb-2\"></div>\n        <small><customer-care ctrl=\"ctrl\"></customer-care></small>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/logoAndCustCare.html
// module id = 784
// module chunks = 0